import { inject } from '@angular/core';
import { StatisticsFacade } from '@zero/statistics/domain';

export class StatisticsPageBase {
  public facade = inject(StatisticsFacade);

  public load = (): void => this.facade.loadStatistics();
  public clean = (): void => this.facade.unsubscribe();
}
